import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { ButtonStyledStyles, ButtonStyles } from '../form/Button';

const Wrapper = styled.div`
  display: flex;
  margin-top: ${rem(24)};
  justify-content: center;
`;

const CtaLink = styled(Link)`
  ${ButtonStyles};
  ${ButtonStyledStyles};

  &.lg {
    padding: ${rem(14)} ${rem(15)};
    ${({ theme }) => theme.media('sm')} {
      font-size: ${rem(16)};
      padding: ${rem(14)} ${rem(40)};
    }
  }
`;

interface Props {
  text: string;
  url: string;
  className?: string;
}

const PageCta = ({ text, url, className }: Props) => (
  <Wrapper className={className}>
    <CtaLink to={url} className="primary lg">
      {text}
    </CtaLink>
  </Wrapper>
);

export default PageCta;
